// extracted by mini-css-extract-plugin
export default {"liveIcon":"styles_liveIcon__c8T6N"};